
const FailedToLoad = () => {
    return (
        <>
            <div >
                ssingout
            </div>
            {/* <ButtonCancel onCancel={onCancel(allContents)} text="標高" /> */}
        </>)
}

export default FailedToLoad;
